
export const receivablesTabEnums = {
  LOADS: 'LOADS',
  LOAD_GROUPS: 'LOAD_GROUPS',
  LOAD_PREPAID: 'LOAD_PREPAID',
};
export const receivablesTabParams = [
  { name: 'Loads', type: receivablesTabEnums?.LOADS },
  { name: 'Load Groups', type: receivablesTabEnums?.LOAD_GROUPS },
  { name: 'Prepaid', type: receivablesTabEnums?.LOAD_PREPAID },
];
